module.exports = __webpack_public_path__ + "img/PINGAN-FPD.1554acad.png";